import { useCallback, useContext, useLayoutEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { useNavigate } from 'react-router-dom';
import { RootState } from '@Store/store';
import { ReactComponent as NotifyIcon } from '@Icons/additional/notification-alt.svg';
import { ReactComponent as NotifyIconAlert } from '@Icons/additional/notification-alertred.svg';
import { Notification } from '@Types/api/notifications';
import { useGetTaskListByRecordIdMutation } from '@Store/api/approvalsListApiSlice';
import { useAppSelector } from '@Hooks/index';
import { currentUserSelector } from '@Store/selectors/userInfoSelector';

import { NotificationContext } from '@Context/NotificationContext';
import NotificationsDrawer from './NotificationsDrawer/NotificationsDrawer';

import './header-actions.css';

const Notify: React.FC = () => {
  const messages = useSelector(
    (state: RootState) => state.common.notifications.messages
  );
  const [isNotificationsOpen, setIsNotificationsOpen] = useState(false);
  const currentUser = useAppSelector(currentUserSelector);
  const { taskIsAlreadyApprovedRejected } = useContext(NotificationContext);
  const navigate = useNavigate();
  const [getTaskByRecordId] = useGetTaskListByRecordIdMutation();

  const [orderedMessages, setOrderedMessages] = useState<Notification[]>([]);

  useLayoutEffect(() => {
    const mappedMessages = messages?.map((item) => item);
    const sortedMessages = mappedMessages?.sort(
      (a, b) =>
        new Date(b.data.eventDateTime).getTime() -
        new Date(a.data.eventDateTime).getTime()
    );

    setOrderedMessages(sortedMessages);
  }, [messages]);

  const handleNotifications = (): void => {
    setIsNotificationsOpen(!isNotificationsOpen);
  };

  const handleSearchTask = useCallback(
    (recordId: string | number, approveFormPath: string): void => {
      getTaskByRecordId({
        searchValue: String(recordId),
        assignee: currentUser.empNumber,
        pageSize: 9,
      })
        .unwrap()
        .then((response) => {
          if (response.length) {
            navigate(approveFormPath);
          } else {
            taskIsAlreadyApprovedRejected();
          }
        });
    },
    [currentUser.empNumber]
  );

  return (
    <>
      <div
        className="header-action-component notify trojan-neumorphism-box trojan-neumorphism-box-shadow"
        onClick={handleNotifications}
      >
        {orderedMessages.some((message) => !message.isRead) ? (
          <NotifyIconAlert />
        ) : (
          <NotifyIcon />
        )}
      </div>

      <NotificationsDrawer
        isOpen={isNotificationsOpen}
        onCancel={handleNotifications}
        data={orderedMessages}
        onSearchTask={handleSearchTask}
      />
    </>
  );
};

export default Notify;
